import { MetricConfig } from './types';

export const dashboardConfig: MetricConfig[] = [
    {
        id: '1',
        title: 'Revenue Trends',
        subtitle: 'Last 5 weeks',
        span: 'lg:col-span-2',
        type: 'chart',
        chartType: 'Line',
        data: [
            { week: 'Week 1', value: 70000 },
            { week: 'Week 2', value: 90000 },
            { week: 'Week 3', value: 80000 },
            { week: 'Week 4', value: 75000 },
            { week: 'Week 5', value: 85000 },
        ],
        chartOptions: {},
    },
    {
        id: '2',
        title: 'Lead Conversion Breakdown',
        subtitle: 'By source',
        span: 'lg:col-span-1',
        type: 'chart',
        chartType: 'Pie',
        data: [
            { type: 'Website', value: 40, color: '#40a9ff' },
            { type: 'Referral', value: 25, color: '#faad14' },
            { type: 'Social Media', value: 20, color: '#9254de' },
            { type: 'Other', value: 15, color: '#52c41a' },
        ],
        chartOptions: {},
    },
    {
        id: '3',
        title: 'Daily Activity Trends',
        subtitle: 'This week',
        span: 'lg:col-span-3',
        type: 'chart',
        chartType: 'MultiLine',
        data: [
            { day: 'Mon', 'Leads Added': 8, 'Calls Made': 15, 'Follow-ups Done': 12, 'Meetings Done': 6 },
            { day: 'Tue', 'Leads Added': 10, 'Calls Made': 18, 'Follow-ups Done': 14, 'Meetings Done': 7 },
            { day: 'Wed', 'Leads Added': 12, 'Calls Made': 16, 'Follow-ups Done': 11, 'Meetings Done': 5 },
            { day: 'Thu', 'Leads Added': 9, 'Calls Made': 17, 'Follow-ups Done': 13, 'Meetings Done': 8 },
            { day: 'Fri', 'Leads Added': 7, 'Calls Made': 14, 'Follow-ups Done': 10, 'Meetings Done': 4 },
            { day: 'Sat', 'Leads Added': 6, 'Calls Made': 12, 'Follow-ups Done': 9, 'Meetings Done': 3 },
            { day: 'Mon', 'Leads Added': 8, 'Calls Made': 15, 'Follow-ups Done': 12, 'Meetings Done': 6 },
        ],
        chartOptions: {},
    },
    {
        id: '4',
        title: 'Lead Sources',
        subtitle: 'Top sources',
        span: 'lg:col-span-1',
        type: 'custom',
        data: [
            { source: 'Website', leads: 120 },
            { source: 'Referral', leads: 85 },
            { source: 'Social Media', leads: 65 },
            { source: 'Email Campaign', leads: 45 },
            { source: 'Other', leads: 25 },
        ],
    },
];

